import React from "react";
import AppWrapper from "../components/wrappers/AppWrapper";
import PDF from '../components/common/pdf'

const LeviasPrivacy = () => {
  return (
    <AppWrapper
      isLeviasLayout
      disableSidebar
      isLeviasTeamAndPrivacy
      disableFooter
      isLeviasHandler={"forgot"}
      className="bg-grey"
      mainbodyClassName="mainbody-pdf"
      leviasPcBlockClass="levias-pc-block-pdf"
    >
      <PDF file="Levias-ID-Privacy-Policy.pdf"/>
    </AppWrapper>
  );
};

export default LeviasPrivacy;
